import {
  faCheckSquare,
  faDownload,
  faSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";

import "./DashboardControls.css";

const DashboardControls = ({
  photosCount,
  selectedCount,
  allSelected,
  onSelectAll,
  onDownloadSelected,
  onDeleteSelected,
  onDownloadAll,
  totalPhotos,
  user,
}) => {
  const hasSelection = selectedCount > 0;
  const { t } = useLanguage();

  return (
    <div className="dashboard-controls">
      <div className="dashboard-controls-container">
        {/* Selection Info */}
        <div className="selection-info">
          <span className="selected-count">
            {hasSelection
              ? `${selectedCount} of ${photosCount} selected`
              : `${photosCount} ${t("commons.photos")}`}
          </span>
          <button
            className="select-all-btn"
            onClick={onSelectAll}
            title={
              allSelected
                ? t("commons.deselectAllPhotos")
                : t("commons.selectAllPhotos")
            }
          >
            <FontAwesomeIcon
              icon={allSelected ? faCheckSquare : faSquare}
              className={allSelected ? "selected" : ""}
            />
            <span>
              {allSelected ? t("commons.deselectAllPhotos") : t("commons.selectAllPhotos")}
            </span>
          </button>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button
            className={`action-btn download-btn ${
              !hasSelection ? "disabled" : ""
            }`}
            onClick={onDownloadSelected}
            disabled={!hasSelection}
          >
            <FontAwesomeIcon icon={faDownload} />
            <span>{t("commons.download")} ({selectedCount})</span>
          </button>

          <button
            className={`action-btn delete-btn ${
              !hasSelection ? "disabled" : ""
            }`}
            onClick={onDeleteSelected}
            disabled={!hasSelection}
          >
            <FontAwesomeIcon icon={faTrash} />
            <span>{t("commons.delete")} ({selectedCount})</span>
          </button>

          {user?.isPremium &&(
            <button
              className="action-btn download-all-btn premium-btn"
              onClick={onDownloadAll}
            >
              <FontAwesomeIcon icon={faDownload} />
              <span>{t("commons.downloadAll")} ({totalPhotos})</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardControls;
